import React from 'react';
import Brands from 'swag-client-common/components/partials/brands';
import Promises from 'swag-client-common/components/partials/promises';
import Distribution from 'swag-client-common/components/partials/distribution';
import CheckOutOurWork from 'swag-client-common/components/partials/check-out-our-work';
import WhatWeDoVideo from 'swag-client-common/components/partials/what-we-do-video';
import headerSwagImage from 'assets/img/home/header-swag.jpg';
import { AutomationSection } from '../../../partials/automation-section';
import { Testimonials } from '../../../partials/testimonials';
import Page from '../../../page';
import { HomepageGallery } from '../../../partials/gallery';
import VerificationLoadingPopup from '../../../popups/verification-loading-popup';
import TopProducts from './components/top-products';
import { AsSeenOn } from './components/as-seen-on';
import { BoxSection } from './components/box-section';
import classes from './home.scss';
const styles = {
  page: {
    backgroundColor: '#fafafa'
  },
  timeline: {
    topBottom: {
      transform: 'translate3d(0px, 0px,0px)'
    },
    bottomTop: {
      transform: 'translate3d(0px, -50px,0px)'
    }
  }
};
const Home = ({
  promoPage = false,
  seoImage,
  headerLink,
  headerLogoContent,
  topProductsCount,
  promoPageStartingPopup,
  promoPageStartingPopupConfig
}) => /*#__PURE__*/React.createElement(Page, {
  headerIsTransparent: true,
  headerLink: headerLink,
  headerLogoContent: headerLogoContent,
  style: styles.page,
  seoImage: seoImage || headerSwagImage,
  promoPage: promoPage,
  headerIsViolet: true,
  promoPageStartingPopup: promoPageStartingPopup,
  promoPageStartingPopupConfig: promoPageStartingPopupConfig
}, /*#__PURE__*/React.createElement(HomepageGallery, null), /*#__PURE__*/React.createElement(Brands, null), /*#__PURE__*/React.createElement(WhatWeDoVideo, null), /*#__PURE__*/React.createElement(Promises, null), /*#__PURE__*/React.createElement(Distribution, {
  mlClassName: classes.distributionMl
}), /*#__PURE__*/React.createElement(TopProducts, {
  topProductsCount: topProductsCount
}), /*#__PURE__*/React.createElement(BoxSection, null), /*#__PURE__*/React.createElement(AutomationSection, null), /*#__PURE__*/React.createElement(Testimonials, null), /*#__PURE__*/React.createElement(CheckOutOurWork, null), /*#__PURE__*/React.createElement(AsSeenOn, null), /*#__PURE__*/React.createElement(VerificationLoadingPopup, null));
export default Home;